module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/megaphone-7bf94fa82bcb17e4ae1662ee57ed4e07.svg";